import {AfterViewInit, Component} from '@angular/core';
import {ControlService, IconService, SubtitlesService} from "../../../core";
import {MenuElementType10, MenuType} from "../../../models";

@Component({
    selector: 'yes-no',
    templateUrl: './yes-no.component.html',
    styleUrls: ['./yes-no.component.scss']
})
export class YesNoComponent implements AfterViewInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setValue(value: 0 | 1): void {
        const element = this.control.elementVal.getValue() as MenuElementType10;
        element.params.value = value;
        this.control.elementVal.next(element);
    }
}
